import { inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { Viewable } from "../../../../../scene/viewable/Viewable";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { PaymentProcessingPopupSceneOptions } from "./PaymentProcessingPopupSceneOptions";
import { PaymentProcessingPopupView } from "../views/PaymentProcessingPopupView";
import { IPaymentProcessingController } from "../controllers/IPaymentProcessingController";
import { Erc20PaymentProcessingResourcePackage } from "../resources/Erc20PaymentProcessingResourcePackage";
import { PaymentResult } from "../../../../../web3/PaymentResult";
import { Web3Model } from "../../../../../web3/models/Web3Model";
import { PaymentProcessingType } from "../type/PaymentProcessingType";
import { CancellationToken } from "../../../../../shared/async/CancellationToken";

@injectable()
export class PaymentProcessingPopupScene extends Viewable<PaymentResult> {
    public constructor(
        commonResources: CommonResourcesPackage,
        monResources: Erc20PaymentProcessingResourcePackage,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("IPaymentProcessingController") paymentProcessingController: IPaymentProcessingController,
        @inject("PaymentProcessingPopupSceneOptions") options: PaymentProcessingPopupSceneOptions<PaymentProcessingType>,
        web3Model: Web3Model,
        cancellationToken: CancellationToken,
        @inject("ILogger") logger: ILogger
    ) {
        super();
        const pcs = new PromiseCompletionSource<PaymentResult>(); 
        this.view = new PaymentProcessingPopupView(
            pcs,
            canvasScaler,
            commonResources,
            monResources,
            paymentProcessingController,
            options,
            web3Model,
            cancellationToken,
            logger
        );
        pcs.result.then((result) => {
            this.operationControls.complete(result);
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        });
    }
}
